<form
    (submit)="submitUser($event)"
    id="userForm"
    [class.hide-business-data]="userForm.businessAttributes().hidden()"
>
    <div id="userData">
        <div class="form-row row-container d-flex flex-column flex-sm-row">
            <div class="form-group col">
                <label
                    for="selectCountry"
                    class="form-label"
                    [class.required]="userForm.businessType().required()"
                    >{{ "Country" | translate }}</label
                >
                <select
                    [formField]="userForm.address.countryCode"
                    class="form-select"
                    id="selectCountry"
                >
                    @for (country of countries(); track country.code) {
                        <option [value]="country.code">
                            {{ country.name }}
                        </option>
                    }
                </select>
            </div>
            <div class="form-group col">
                <label
                    for="selectLanguage"
                    class="form-label"
                    [class.required]="userForm.languageCode().required()"
                    >{{ "language" | translate }}</label
                >
                <select
                    [formField]="userForm.languageCode"
                    class="form-select"
                    id="selectLanguage"
                >
                    @for (language of languages(); track language.code) {
                        <option [value]="language.code">
                            {{ language.name }}
                        </option>
                    }
                </select>
            </div>
        </div>
        <div class="form-row row-container d-flex flex-column flex-sm-row">
            <div class="form-group col">
                <label
                    for="inputBusinessType"
                    class="form-label"
                    [class.required]="userForm.businessType().required()"
                    >{{ "businessExt" | translate }}</label
                >
                <select
                    [formField]="userForm.businessType"
                    class="form-select"
                    id="inputBusinessType"
                >
                    <option value="cp">
                        {{ "contactPerson" | translate }}
                    </option>
                    <option value="df">{{ "different" | translate }}</option>
                    <option value="no">{{ "notBusiness" | translate }}</option>
                </select>
            </div>
        </div>
        @if (!userForm.nameOfBusiness().hidden()) {
            <div
                class="form-row row-container d-flex flex-column flex-sm-row"
                animate.enter="enter-animation"
                animate.leave="leave-animation"
            >
                <div class="form-group col">
                    <label
                        for="nameOfBusiness"
                        class="form-label"
                        [class.required]="userForm.nameOfBusiness().required()"
                        >{{ "company" | translate }}</label
                    >
                    <input
                        [formField]="userForm.businessAttributes.name"
                        class="form-control"
                        type="text"
                        id="nameOfBusiness"
                    />
                </div>
            </div>
        }
        <div class="form-row row-container d-flex flex-column flex-sm-row">
            <div class="form-group col">
                <label
                    class="form-label"
                    for="gender"
                    [class.required]="userForm.gender().required()"
                    >{{ "title" | translate }}</label
                >
                <select
                    class="form-select"
                    style="max-width: 120px"
                    [formField]="userForm.gender"
                    autocomplete="sex"
                    id="gender"
                >
                    <option value=""></option>
                    <option value="m">{{ "Mr" | translate }}</option>
                    <option value="f">{{ "Ms" | translate }}</option>
                    <option value="d">{{ "Diverse" | translate }}</option>
                </select>
            </div>
        </div>
        <div class="form-row row-container d-flex flex-column flex-sm-row">
            <div class="form-group col">
                <label
                    class="form-label"
                    for="firstName"
                    [class.required]="userForm.firstName().required()"
                    >{{ "Firstname" | translate }}</label
                >
                <input
                    class="form-control"
                    type="text"
                    [formField]="userForm.firstName"
                    autocomplete="given-name"
                    id="firstName"
                />
            </div>
            <div class="form-group col">
                <label
                    class="form-label"
                    for="lastName"
                    [class.required]="userForm.lastName().required()"
                    >{{ "Lastname" | translate }}</label
                >
                <input
                    class="form-control"
                    type="text"
                    [formField]="userForm.lastName"
                    autocomplete="family-name"
                    id="lastName"
                />
            </div>
        </div>
        <app-address-input
            (addressSchema)="(addressSchema)"
            [addressInput]="userForm.address"
        ></app-address-input>
        <div class="form-row row-container d-flex flex-column flex-sm-row">
            <div class="form-group col">
                <label for="inputPhoneNumber" class="form-label">{{
                    "phoneNumber" | translate
                }}</label>
                <input
                    type="tel"
                    [formField]="userForm.phoneNumber"
                    class="form-control"
                    id="inputPhoneNumber"
                />
            </div>
        </div>
        @if (userForm().errors().length > 0) {
            <div
                class="error-list form-row row-container d-flex flex-column flex-sm-row"
            >
                @for (error of userForm().errors(); track error) {
                    <p class="error-message form-group col">
                        {{ error.message | translate }}
                    </p>
                }
            </div>
        }
    </div>
    @if (!userForm.businessAttributes().hidden()) {
        <app-business-profile-input
            animate.enter="enter-animation-horizontal"
            animate.leave="leave-animation-horizontal"
            id="businessData"
            [businessProfileInput]="userForm.businessAttributes"
        ></app-business-profile-input>
    }
    <div class="d-flex submit-area" style="align-items: center; gap: 5px;">
        <button
            id="submitButton"
            class="button btn-poettinger"
            type="submit"
            [disabled]="userForm().submitting()"
        >
            {{ "Save" | translate }}
        </button>
        @if (userForm().submitting()) {
            <ion-spinner></ion-spinner>
        }
    </div>
</form>
